import { useState } from 'react'

const TextConsent = ({chosenType}) => {



  return(
    <></>
  )
}

export default TextConsent